import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ComponentStylePublicAPI} from '@wix/document-services-public-types'
import {componentStylesAndSkinsAPI, idGenerator, refComponent} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ComponentStylePublicAPI> {
    const {
        defineGetter,
        deprecate,
        actions: {dataManipulation},
        extensionPublicAPI
    } = publicMethodUtils

    return {
        methods: {
            style: {
                getColorsListInAllComponents: extensionPublicAPI.getter('style.getColorsListInAllComponents'),
                replaceColorInAllComponents: extensionPublicAPI.dataManipulation('style.replaceColorInAllComponents'),
                getComponentsUsingStyle: extensionPublicAPI.getter('style.getComponentsUsingStyle')
            },
            components: {
                style: {
                    getId: defineGetter(componentStylesAndSkinsAPI.style.getId),
                    get: defineGetter(componentStylesAndSkinsAPI.style.get),
                    update: dataManipulation(componentStylesAndSkinsAPI.style.update, {
                        isUpdatingAnchors: refComponent.shouldUpdateAnchors
                    }),

                    setCustom: deprecate(
                        dataManipulation(componentStylesAndSkinsAPI.style.setCustom, {
                            getReturnValue: idGenerator.getStyleIdToAdd
                        }),
                        'This API is deprecated. Please either use components.style.update or components.style.fork instead'
                    ),
                    isSystemStyle: defineGetter(componentStylesAndSkinsAPI.style.isSystemStyle),
                    connectToTheme: dataManipulation(componentStylesAndSkinsAPI.style.connectToThemeStyle),
                    fork: dataManipulation(componentStylesAndSkinsAPI.style.fork),
                    scoped: {
                        remove: dataManipulation(componentStylesAndSkinsAPI.style.removeScoped)
                    }
                }
            }
        }
    }
}
